import { useMutation, useQueryClient } from '@tanstack/react-query';

import { startPolicy } from '@/policy/api/StartPolicy';

interface Props {
  uuid: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useStartPolicy = ({ uuid, onSuccess, onError }: Props) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: () => startPolicy(uuid),
    onSuccess: () => {
      onSuccess();
      queryClient.invalidateQueries({ queryKey: ['policies'] });
    },
    onError,
  });

  return { start: mutate };
};
